import gql from 'graphql-tag';

export default gql`
mutation updatePersonalizedVariableSet($obj: updatePersonalizedVariableSetInput!) {
  updatePersonalizedVariableSet(object: $obj) {
    updatedPersonalizedVariableSetId
  }
}
`;
